module.exports = __webpack_public_path__ + "img/ba9d9ec.png";